(() => {
  const api = window.WahupOptionTapSound || {};
  if (api.bindRoots) {
    api.bindRoots();
    return;
  }

  let audioContext = null;
  let soundBuffer = null;
  let soundLoad = null;
  let lastStartedAt = 0;
  const textEntrySelector = [
    'textarea[data-wahup-customily-input]',
    'input[data-wahup-customily-input]:not([type="checkbox"]):not([type="file"]):not([type="hidden"]):not([type="radio"]):not([type="range"]):not([type="color"])',
  ].join(', ');

  const roots = () => [...document.querySelectorAll(
    '[data-wahup-customily-root][data-wahup-interaction-sound-url]',
  )];
  const setStatus = (status) => roots().forEach((root) => {
    root.dataset.wahupOptionSoundStatus = status;
  });
  const ensureAudioContext = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) {
      setStatus('unsupported');
      return null;
    }
    if (!audioContext || audioContext.state === 'closed') audioContext = new AudioContextClass();
    return audioContext;
  };
  const soundUrl = () => roots()[0]?.dataset.wahupInteractionSoundUrl || '';
  const prepareSound = (context) => {
    const url = soundUrl();
    if (!context || !url) return Promise.resolve(null);
    if (soundBuffer) return Promise.resolve(soundBuffer);
    if (!soundLoad) {
      setStatus('loading');
      soundLoad = fetch(url, { cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error(`Option sound returned ${response.status}`);
          return response.arrayBuffer();
        })
        .then((encoded) => context.decodeAudioData(encoded.slice(0)))
        .then((decoded) => {
          soundBuffer = decoded;
          setStatus('ready');
          return decoded;
        })
        .catch(() => {
          setStatus('error');
          return null;
        })
        .finally(() => {
          soundLoad = null;
        });
    }
    return soundLoad;
  };
  const resumeAudioContext = async () => {
    const context = ensureAudioContext();
    if (!context) return null;
    if (context.state === 'suspended') {
      try {
        await context.resume();
      } catch (error) {
        setStatus('blocked');
        return null;
      }
    }
    return context.state === 'running' ? context : null;
  };
  const play = async (root) => {
    const now = Date.now();
    if (now - lastStartedAt < 120) return;
    lastStartedAt = now;
    const context = await resumeAudioContext();
    const buffer = await prepareSound(context);
    if (!context || !buffer) {
      lastStartedAt = 0;
      return;
    }
    const startedAt = context.currentTime;
    const source = context.createBufferSource();
    const gain = context.createGain();
    source.buffer = buffer;
    gain.gain.setValueAtTime(.95, startedAt);
    source.connect(gain);
    gain.connect(context.destination);
    source.start(startedAt);
    root.dataset.wahupOptionSoundStatus = 'played';
    root.dataset.wahupOptionSoundPlayCount = String(
      Number(root.dataset.wahupOptionSoundPlayCount || 0) + 1,
    );
  };
  const unlock = () => {
    const context = ensureAudioContext();
    if (context?.state === 'suspended') void context.resume();
    if (context) void prepareSound(context);
  };
  const bindRoot = (root) => {
    if (root.dataset.wahupOptionSoundInitialized === 'true') return;
    root.dataset.wahupOptionSoundInitialized = 'true';
    root.dataset.wahupOptionSoundStatus = 'idle';
    const playTextEntryTap = (event) => {
      const input = event.target.closest(textEntrySelector);
      if (input && !input.disabled && !input.readOnly) void play(root);
    };
    root.addEventListener('pointerdown', playTextEntryTap, { passive: true });
    root.addEventListener('touchstart', playTextEntryTap, { passive: true });
    root.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-wahup-customily-set]');
      if (choice && !choice.disabled) void play(root);
    });
    root.addEventListener('change', (event) => {
      const input = event.target.closest('[data-wahup-customily-input]');
      if (input && (input.matches('select') || input.matches('input[type="checkbox"]'))) void play(root);
    });
  };
  const bindRoots = () => roots().forEach(bindRoot);

  api.bindRoots = bindRoots;
  window.WahupOptionTapSound = api;
  document.addEventListener('pointerdown', unlock, { passive: true });
  document.addEventListener('keydown', unlock, { passive: true });
  document.addEventListener('shopify:section:load', bindRoots);
  bindRoots();
  const preloadContext = ensureAudioContext();
  if (preloadContext) void prepareSound(preloadContext);
})();
